import { t } from '@lingui/core/macro'
import { useMemo } from 'react'
import Col from 'react-bootstrap/Col'
import MultiSelect from '~/components/multi_select'
import Select from '~/components/select'
import DashboardFilters from '~/dashboard/dashboard_filters'
import useChartFilters from '~/hooks/use_chart_filters'
import {
  azureLocationsChartOptionPath,
  azureMeterCategoriesChartOptionPath,
  azureMeterSubCategoriesChartOptionPath,
  azureProductsChartOptionPath,
  azureServicesChartOptionPath,
  azureSubscriptionsChartOptionPath,
} from '~/routes'
import { azureCostKinds } from '~/utils/azure'

export default function AzureDashboardFilters({ organizationId: orgId, setChartParams }) {
  const [onApply, onReset, onChange, params] = useChartFilters(setChartParams)

  const subscriptionsUrl = useMemo(() => azureSubscriptionsChartOptionPath(orgId), [orgId])
  const locationsUrl = useMemo(() => azureLocationsChartOptionPath(orgId), [orgId])
  const servicesUrl = useMemo(() => azureServicesChartOptionPath(orgId), [orgId])
  const productsUrl = useMemo(() => azureProductsChartOptionPath(orgId), [orgId])
  const meterCategoriesUrl = useMemo(() => azureMeterCategoriesChartOptionPath(orgId), [orgId])
  const meterSubCategoriesUrl = useMemo(() => azureMeterSubCategoriesChartOptionPath(orgId), [orgId])

  return (
    <DashboardFilters onApply={onApply} onReset={onReset}>
      <Col>
        <MultiSelect
          label={t`Subscription`}
          name='azureSubscriptionIds'
          onChange={onChange}
          url={subscriptionsUrl}
          selected={params.azureSubscriptionIds}
        />
      </Col>
      <Col>
        <MultiSelect
          label={t`Locations`}
          name='azureResourceLocations'
          onChange={onChange}
          url={locationsUrl}
          params={params}
          selected={params.azureResourceLocations}
        />
      </Col>
      <Col>
        <MultiSelect
          label={t`Service Family`}
          name='azureServices'
          onChange={onChange}
          url={servicesUrl}
          params={params}
          selected={params.azureServices}
        />
      </Col>
      <Col>
        <MultiSelect
          label={t`Product`}
          name='azureProducts'
          onChange={onChange}
          url={productsUrl}
          params={params}
          selected={params.azureProducts}
        />
      </Col>
      <Col>
        <MultiSelect
          label={t`Meter Category`}
          name='azureMeterCategories'
          onChange={onChange}
          url={meterCategoriesUrl}
          params={params}
          selected={params.azureMeterCategories}
        />
      </Col>
      <Col>
        <MultiSelect
          label={t`Meter sub category`}
          name='azureMeterSubCategories'
          onChange={onChange}
          url={meterSubCategoriesUrl}
          params={params}
          selected={params.azureMeterSubCategories}
        />
      </Col>
      <Col>
        <Select
          label={t`Cost Kind`}
          name='azureCostKind'
          onChange={onChange}
          options={azureCostKinds()}
          selected={params.azureCostKind}
        />
      </Col>
    </DashboardFilters>
  )
}
